angular.module('impactx.autocompleteselection').controller('AutocompleteSelectionPanelCtrl', [
    'config',
    'AutocompleteSelectionPanel',
    'dataGen',
    '$filter',
    'TranslationService',
    'themeFactory',
    '$element',
    '$timeout',
    AutocompleteSelectionPanelController]);

function AutocompleteSelectionPanelController(config, AutocompleteSelectionPanel, dataGen, $filter, TranslationService,
                                              themeFactory, $element, $timeout) {
    var doFocus = config && config.focusSearchInput;
    var firstLoadOnSearch = config && config.firstLoadOnSearch;
    var clearOnEmptySearch = config && config.clearOnEmptySearch;
    
    var self = this;
    self.theme = themeFactory.getTheme();
    self.searchText = "";
    self.entries = [];
    self.isLoading = false;
    self.trns = {
        search: TranslationService.get('search')
    };

    if (!firstLoadOnSearch) {
        getEntries();
    }

    self.queryEntries = function () {
        if(clearOnEmptySearch && !self.searchText) {
            self.entries = [];
        }
        else {
            getEntries();
        }
    };

    self.selectEntry = function (entry) {
        if (entry) {
            AutocompleteSelectionPanel.setSelection(entry);
            AutocompleteSelectionPanel.closePanel();
        }
    };

    function getEntries() {
        self.isLoading = true;
        var parameters = self.config.parameters || {};
        parameters.searchText = self.searchText;

        dataGen.getData(self, parameters, self.config.uri).then(function (response) {
            if (impactX.isDefined(response, 'data')) {
                self.entries = filterResult(response.data.entries);
            }
            self.isLoading = false;
        });
    }

    function filterResult(response) {
        if (self.config.selected) {
            return $filter('filter')(response, function (value) {
                var contains = true;
                for (var i = 0; i < self.config.selected.length; i++) {
                    contains = self.config.selected[i].id !== value.id;
                    if (!contains) {
                        break;
                    }
                }
                return contains;
            })
        }
        else {
            return response;
        }
    }

    if(doFocus) {
        // need a little bit of time before we can focus the input
        $timeout(function() {
            var allInputs = $element[0].querySelectorAll('input');
            var input = allInputs[allInputs.length - 1];
            input && input.focus();
        }, 100);
    }
}